import { AUTH_TOKEN_KEY } from '../constants'

export default function auth({ next, router }) {
    if (!localStorage.getItem(AUTH_TOKEN_KEY) || localStorage.getItem(AUTH_TOKEN_KEY) == 'null') {
        return next({ name: 'LoginInfo' })
    } else {
        return next();
    }
}